import React, { useEffect } from "react";
import "../pages/styles/team.css";
import "../pages/styles/home.css";
import "./styles/mediaqueries.css";
import logo from "../Assets/images/Logo_Square_mini.png";
import michael from "../Assets/images/michael.png";
import ryan from "../Assets/images/ryan.png";
import david from "../Assets/images/david.png";
import tony from "../Assets/images/tony.png";
import matt from "../Assets/images/matt.png";
import rong from "../Assets/images/rong.png";
import tomas from "../Assets/images/tomas.jpeg";
import pm from "../Assets/images/Team_PMstudios_Logo.png";
import out from "../Assets/images/Team_Nhancestudios_Logo.png";
import Footer from "../components/Footer";
import frame from "../Assets/images/Team_Member_Frame.png";
import frameHalf from "../Assets/images/Team_Partners_Frame01.png";
import discordLogo from "../Assets/images/Team_Disocord_Logo.png";
import ourStory from "../Assets/images/Team_Img01.png";
import issac from "../Assets/images/issac.png";
import hyunkyung from "../Assets/images/Hyunkyung.png";
import rahul from "../Assets/images/rahul.png";
import antoan from "../Assets/images/Antoan.jpg";
import anas from "../Assets/images/anas.png";

const Team = () => {
  useEffect(() => {
    document.title = "Roshpit Champions II | Our Team";
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="team_section1">
        <div className="team_section1_heading">
          <p>the roshpit mission</p>
          <span>To become the most fun game you will ever play.</span>
        </div>
      </div>
      <div className="team_outstory">
        <div className="team_outstory_container">
          <img src={ourStory} alt="" srcset="" />
          <div className="our_story">
            <p>our story</p>
            <h3>
              ‘ Roshpit Champions was born from an idea after playing hours and
              hours of DOTA2. ’
            </h3>
            <h6>
              Ryan "ChalkyBrush" Raciopppo dabbled with the map editor and
              thought that it would be awesome to create an action RPG
              adventure.
            </h6>
            <h6>
              He started work on the first iteration in 2016 and within two
              years, had over 100,000 user accounts. A year later, with him
              releasing his version 3.2 update, there were over 230,000 user
              accounts created. In 2020, with the version 4.0 update,
              ChalkyBrush partnered with Valve and became the first mod to
              incorporate a Battle Pass functionality - establishing the game as
              a recognized mod in the community. By 2020, no doubt due to the
              relationship with Valve, the game skyrocketed in popularity and
              had over 2 million subscribers.
            </h6>
            <h6>
              The game caught the eye of the Producer, David "Oppa" Whang, as he
              was looking to play some mods after getting pummeled much too
              often in DOTA2. Within the first hour, Oppa knew that this mod was
              special. As he instantly became hooked, he was astounded that
              someone could take elements of Diablo 2, DOTA2, and some of his
              other favorite games and combine them to create such an awesome
              mod. He reached out to several people and Michael "Bnis" Yum, CEO
              of PM Studios, bought in immediately. As someone working in the
              gaming industry for over 20 years, and having made many hit games,
              Michael knew ChalkyBrush's vision was sound. From there, PM
              Champions was born.
            </h6>
            <h6>
              The PM Champions Team has been working on this project since the
              end of 2020 and we are super excited to release this game soon. We
              would love for everyone who enjoyed Roshpit Champions before to
              come and try this new and improved game with us. As we consider
              ourselves a community based game, we would love to grow and shape
              the future of the game with you. Please considering becoming a
              part of our Discord community.
            </h6>
          </div>
        </div>
      </div>
      <div className="team_container">
        <p className="team_container_heading">Our Team</p>
        <span className="team_container_span">
          Roshpit Champions II is the ongoing result of countless hours of
          dedication, sleepless nights, and the relentless pursuit of excellence
          - driven by the unwavering belief that games can be more than just
          entertainment; they can be immersive, emotional journeys that players
          will remember for years to come. We hope you enjoy our game for years
          to come and be a part of our journey in building the most fun game,
          together.
        </span>
        <div className="cards_container">
          <div className="team_card_wrapper">
            <div className="team_card_main">
              <div className="team_card">
                <div className="team_card_front">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />
                  <div className="team_card_front_image">
                    <img src={michael} alt="Michael Yum" />
                  </div>
                </div>
                <div className="team_card_back">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />
                  <ul>
                    <li>
                      <p>CEO of PM Studios.</p>
                    </li>
                    <li>
                      <p>25+ Years in Gaming Industry.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p className="team_card_name">Michael Yum</p>
            <span className="team_card_designation">Lead Producer</span>
          </div>
          <div className="team_card_wrapper">
            <div className="team_card_main">
              <div className="team_card">
                <div className="team_card_front">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />
                  <div className="team_card_front_image">
                    <img src={ryan} alt="Ryan Racioppo" />
                  </div>
                </div>
                <div className="team_card_back">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />

                  <ul>
                    <li>
                      <p>Creator of Roshpit Champions.</p>
                    </li>
                    <li>
                      <p>10+years Coding Experience</p>
                    </li>
                    <li>
                      <p>6 Years in Gaming.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p className="team_card_name">Ryan Racioppo</p>
            <span className="team_card_designation">Head Developer</span>
          </div>
          <div className="team_card_wrapper">
            <div className="team_card_main">
              <div className="team_card">
                <div className="team_card_front">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />
                  <div className="team_card_front_image">
                    <img src={david} alt="" />
                  </div>
                </div>
                <div className="team_card_back">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />

                  <ul>
                    <li>
                      <p>15+ Years Project Management</p>
                    </li>
                    <li>
                      <p>4 Years Gaming Development & Logistics</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p className="team_card_name">David Whang</p>
            <span className="team_card_designation">Executive Director</span>
          </div>
          <div className="team_card_wrapper">
            <div className="team_card_main">
              <div className="team_card">
                <div className="team_card_front">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />
                  <div className="team_card_front_image">
                    <img src={tony} alt="Tony Kornilov" />
                  </div>
                </div>
                <div className="team_card_back">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />

                  <ul>
                    <li>
                      <p>6 Years Coding Experience.</p>
                    </li>
                    <li>
                      <p>6 Years in Gaming, Modding, Deconstructing.</p>
                    </li>
                    <li>
                      <p>Specialized in Network Programming.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p className="team_card_name">Tony Kornilov</p>
            <span className="team_card_designation">Senior Developer</span>
          </div>
          <div className="team_card_wrapper">
            <div className="team_card_main">
              <div className="team_card">
                <div className="team_card_front">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />
                  <div className="team_card_front_image">
                    <img src={matt} alt="Matt Kulmanov" />
                  </div>
                </div>
                <div className="team_card_back">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />

                  <ul>
                    <li>
                      <p>10 Years Animation Experience.</p>
                    </li>
                    <li>
                      <p>6 Years in Gaming Design.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p className="team_card_name">Matt Kulmanov</p>
            <span className="team_card_designation">Animator / Artist</span>
          </div>
          <div className="team_card_wrapper">
            <div className="team_card_main">
              <div className="team_card">
                <div className="team_card_front">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />
                  <div className="team_card_front_image">
                    <img src={tomas} alt="Seth Lowe" />
                  </div>
                </div>

                <div className="team_card_back">
                  <img
                    className="team_card_back_frame"
                    src={frameHalf}
                    alt=""
                    srcset=""
                  />

                  <ul>
                    <li>
                      <p>World Renowned Composer</p>
                    </li>
                    <li>
                      <p>Czech Republic Honorary Medal Recipient</p>
                    </li>
                    <li>
                      <p>+35 years in Music Composition</p>
                    </li>
                    <li>
                      <p>+5 years in Film/Gaming Music</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p className="team_card_name">Tomáš Kačo</p>
            <span className="team_card_designation">
              Music Director / Composer
            </span>
          </div>
          <div className="team_card_wrapper">
            <div className="team_card_main">
              <div className="team_card">
                <div className="team_card_front">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />
                  <div className="team_card_front_image">
                    <img src={rong} alt="Seth Lowe" />
                  </div>
                </div>

                <div className="team_card_back">
                  <img
                    className="team_card_back_frame"
                    src={frameHalf}
                    alt=""
                    srcset=""
                  />

                  <ul>
                    <li>
                      <p>Vocal Performance/VA for 3+ years</p>
                    </li>
                    <li>
                      <p>2 year Video Game Writing</p>
                    </li>
                    <li>
                      <p>8 years Audio/Music Editing</p>
                    </li>
                    <li>
                      <p>9 years Creative Writing</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p className="team_card_name">Seth Lowe</p>
            <span className="team_card_designation">
              Story/ Character Lore /Voice Actor
            </span>
          </div>
          <div className="team_card_wrapper">
            <div className="team_card_main">
              <div className="team_card">
                <div className="team_card_front">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />
                  <div className="team_card_front_image">
                    <img src={issac} alt="Isaac Minor" />
                  </div>
                </div>
                <div className="team_card_back">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />

                  <ul>
                    <li>
                      <p>10 years Vocal Performance and Voice Acting</p>
                    </li>
                    <li>
                      <p>9 years Creative Writing</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p className="team_card_name">Isaac Minor</p>
            <span className="team_card_designation">
              {" "}
              Story/ Character Lore /Voice Actor
            </span>
          </div>
          <div className="team_card_wrapper">
            <div className="team_card_main">
              <div className="team_card">
                <div className="team_card_front">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />
                  <div className="team_card_front_image">
                    <img src={antoan} alt="Antoan Simic" />
                  </div>
                </div>
                <div className="team_card_back">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />

                  <ul>
                    <li>
                      <p>15+ years in Character Creation and 3D Modeling.</p>
                    </li>
                    <li>
                      <p>Drawing since out of the womb.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p className="team_card_name">Antoan Simic</p>
            <span className="team_card_designation">
              {" "}
              Lead Artist / 3D Character Modeling
            </span>
          </div>
          <div className="team_card_wrapper">
            <div className="team_card_main">
              <div className="team_card">
                <div className="team_card_front">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />
                  <div className="team_card_front_image">
                    <img src={hyunkyung} alt="Hyunkyung So" />
                  </div>
                </div>
                <div className="team_card_back">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />

                  <ul>
                    <li>
                      <p>10+ years Graphic Design Experience.</p>
                    </li>
                    <li>
                      <p>2 years in Game UI Art.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p className="team_card_name">Hyunkyung So</p>
            <span className="team_card_designation"> UI Artist</span>
          </div>
          <div className="team_card_wrapper">
            <div className="team_card_main">
              <div className="team_card">
                <div className="team_card_front">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />
                  <div className="team_card_front_image">
                    <img src={rahul} alt="Rahul Rana" />
                  </div>
                </div>
                <div className="team_card_back">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />

                  <ul>
                    <li>
                      <p>Developer of this website.</p>
                    </li>
                    <li>
                      <p>
                        4+ years of experience in Software Industry creating
                        cool websites and apps.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p className="team_card_name">Rahul Rana</p>
            <span className="team_card_designation">Web Designer</span>
          </div>
          <div className="team_card_wrapper">
            <div className="team_card_main">
              <div className="team_card">
                <div className="team_card_front">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />
                  <div className="team_card_front_image">
                    <img src={anas} alt="Anas Riasat" />
                  </div>
                </div>
                <div className="team_card_back">
                  <img
                    className="team_card_back_frame"
                    src={frame}
                    alt=""
                    srcset=""
                  />

                  <ul>
                    <li>
                      <p>20+ years in Games and Animation</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p className="team_card_name">Anas Riasat</p>
            <span className="team_card_designation">
              Art Direction/ Senior Concept Artist
            </span>
          </div>
        </div>
        <div className="other_container">
          <div className="studio_members">
            <img
              className="team_card_back_frame"
              src={frameHalf}
              alt=""
              srcset=""
            />
            <span>PM Studios Development Team</span>
            <div className="studio_members_image">
              <img src={pm} alt="pm studios logo" />
            </div>
          </div>
          <div className="outsourced_members">
            <img
              className="team_card_back_frame"
              src={frameHalf}
              alt=""
              srcset=""
            />
            <span>Outsourced Art Team</span>
            <div className="outsourced_members_image">
              <img src={out} alt="outsourced" />
            </div>
          </div>
          <div className="other_members">
            <img
              className="team_card_back_frame"
              src={frameHalf}
              alt=""
              srcset=""
            />
            <span>Other Artists</span>
            <div className="other_members_members">
              <p>Toni Nguyen</p>
              <p>George 'Chark' Romulo</p>
              <p>Emily Lowe</p>
              <p>Rohg Choi</p>
            </div>
          </div>
          {/* <div className="studio_members_members">
            <img
              className="team_card_back_frame"
              src={frameHalf}
              alt=""
              srcset=""
            />
            <span>Web Designer</span>
            <a href="https://www.instagram.com/rahul.jpg/" target="_">
              <p>Rahul Rana</p>
            </a>
          </div> */}
          <div className="discord_members">
            <img
              className="team_card_back_frame"
              src={frameHalf}
              alt=""
              srcset=""
            />
            <span>AND YOU</span>
            <a href="https://discord.gg/ZPbpdjxTsF" target="_">
              <img src={discordLogo} alt="" srcset="" />
              <p>Roshpit Champions Community</p>
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Team;
